import React from 'react';
import { Search } from 'lucide-react';
import styles from '../styles/TableSearchBar.module.css';

/**
 * Reusable search bar for filtering table data.
 * @param {string} value - Current search value
 * @param {function} onChange - Called when input changes (e) => void
 * @param {string} [placeholder='Search...'] - Input placeholder
 * @param {string} [className] - Optional extra class name
 */
const TableSearchBar = ({ value, onChange, placeholder = 'Search...', className = '' }) => (
  <div className={`${styles.searchWrap} ${className}`}>
    <Search size={18} className={styles.searchIcon} aria-hidden />
    <input
      type="search"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={styles.searchInput}
      aria-label="Search table"
    />
  </div>
);

export default React.memo(TableSearchBar);
